var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyFeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "EmptyFeed_svg__a",
    cx: 80,
    cy: 80,
    r: 80
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 80,
    cy: 80,
    r: 80
  }), /*#__PURE__*/React.createElement("mask", {
    id: "EmptyFeed_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EmptyFeed_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#EmptyFeed_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#EmptyFeed_svg__b)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.111 66.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.615 0h92.548a2.615 2.615 0 012.615 2.615v21.437a2.615 2.615 0 01-2.615 2.615H2.615A2.615 2.615 0 010 24.052V2.615A2.615 2.615 0 012.615 0z",
    fill: "#F6D9ED"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F0C0E1",
    cx: 11.556,
    cy: 11.556,
    r: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F0C0E1",
    x: 24.889,
    y: 6.222,
    width: 62.222,
    height: 2.667,
    rx: 1.167
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F0C0E1",
    x: 24.889,
    y: 12.444,
    width: 48,
    height: 2.667,
    rx: 1.167
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F0C0E1",
    x: 24.889,
    y: 18.667,
    width: 21.333,
    height: 2.667,
    rx: 1.167
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#EmptyFeed_svg__b)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.111 100.444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.615 0h92.548a2.615 2.615 0 012.615 2.615v21.437a2.615 2.615 0 01-2.615 2.615H2.615A2.615 2.615 0 010 24.052V2.615A2.615 2.615 0 012.615 0z",
    fill: "#FDF0CC"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FCE7AB",
    cx: 11.556,
    cy: 11.556,
    r: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FCE7AB",
    x: 24.889,
    y: 6.222,
    width: 62.222,
    height: 2.667,
    rx: 1.167
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FCE7AB",
    x: 24.889,
    y: 12.444,
    width: 48,
    height: 2.667,
    rx: 1.167
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FCE7AB",
    x: 24.889,
    y: 18.667,
    width: 21.333,
    height: 2.667,
    rx: 1.167
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#EmptyFeed_svg__b)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.111 32.889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.615 0h92.548a2.615 2.615 0 012.615 2.615v21.437a2.615 2.615 0 01-2.615 2.615H2.615A2.615 2.615 0 010 24.052V2.615A2.615 2.615 0 012.615 0z",
    fill: "#D9EED8"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C0E3BF",
    cx: 11.556,
    cy: 11.556,
    r: 5.333
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C0E3BF",
    x: 24.889,
    y: 6.222,
    width: 62.222,
    height: 2.667,
    rx: 1.167
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C0E3BF",
    x: 24.889,
    y: 12.444,
    width: 48,
    height: 2.667,
    rx: 1.167
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C0E3BF",
    x: 24.889,
    y: 18.667,
    width: 21.333,
    height: 2.667,
    rx: 1.167
  }))))));
}
export default SvgEmptyFeed;